import React from "react";
import {Auth} from "aws-amplify";
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";


function ProfileWizardHeader(props: { cognitoUser: object, step: number, maxSteps: number }) {
  const {cognitoUser, step, maxSteps} = props
  const email = (cognitoUser as any).attributes?.email;
  const message = step === maxSteps ? "Setup complete!" : `Setup step ${step}`

  async function signOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  return (
    <section className="container px-0 rounded">
      <nav className="navbar navbar-dark mt-3">
        <div className="navbar-brand">
          <h3>
            <Link to="/home">
              <img className="logoVilla" src="/villa.png" width="64" height="64" alt=""/>
            </Link>
            {message}
          </h3>
        </div>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"/>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto pt-4 text-right">
            <li className="nav-item pb-3">
              <Link to="/terms">
                <span>Terms of Use</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <Link to="/privacy">
                <span>Privacy Policy</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <a href="https://www.villa.rocks">
                <span>Villa Rocks</span>
              </a>
            </li>
            <li className="nav-item pb-2">
              <span>{email}</span>
            </li>
            <li className="nav-item dropdown">
              <Button onClick={signOut}>
                Sign Out
              </Button>
            </li>
          </ul>
        </div>
      </nav>
    </section>
  )
}

export default ProfileWizardHeader;
